export const GalleryArrow = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      {...props}
    >
      <g mask='url(#mask0_736_851)'>
        <path
          d='M16.4937 5.25833L9.80199 11.8583C9.71865 11.9417 9.71865 12.075 9.80199 12.15L16.4937 18.75L13.227 18.75L8.21865 13.7417C7.26032 12.7833 7.26032 11.225 8.21865 10.2667L13.227 5.25833L16.4937 5.25833Z'
          fill='#200000'
        />
      </g>
    </svg>
  );
};
